/* Structured article — auto-generated table of contents + related-posts carousel */
(function () {
  'use strict';

  function slugify(text) {
    return (text || '')
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function buildTOC() {
    var article = document.querySelector('.krumb-article');
    if (!article) return;
    var body = article.querySelector('.krumb-article__body');
    var toc = article.querySelector('[data-krumb-toc]');
    if (!body || !toc) return;

    var headings = body.querySelectorAll('h2, h3');
    if (!headings.length) {
      toc.setAttribute('hidden', '');
      return;
    }

    var seen = {};
    var list = document.createElement('ol');
    list.className = 'krumb-toc__list';

    headings.forEach(function (h) {
      var base = h.id || slugify(h.textContent);
      if (!base) base = 'section';
      var id = base;
      var n = 2;
      while (seen[id]) {
        id = base + '-' + n;
        n += 1;
      }
      seen[id] = true;
      h.id = id;

      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = h.textContent;
      li.appendChild(a);

      if (h.tagName === 'H2') {
        list.appendChild(li);
      } else {
        var lastTopItem = list.lastElementChild;
        if (lastTopItem) {
          var sub = lastTopItem.querySelector('ol.krumb-toc__sublist');
          if (!sub) {
            sub = document.createElement('ol');
            sub.className = 'krumb-toc__sublist';
            lastTopItem.appendChild(sub);
          }
          sub.appendChild(li);
        } else {
          list.appendChild(li);
        }
      }
    });

    toc.appendChild(list);

    if (window.matchMedia && window.matchMedia('(max-width: 767px)').matches) {
      toc.removeAttribute('open');
    } else {
      toc.setAttribute('open', '');
    }
  }

  /* Related-posts carousel: native scroll-snap track + prev/next buttons.
     Buttons reveal only when the track overflows (and are hidden on mobile
     via CSS, where finger-swipe is used instead). */
  function buildCarousels() {
    var carousels = document.querySelectorAll('[data-krumb-carousel]');
    carousels.forEach(function (car) {
      var track = car.querySelector('.krumb-carousel__track');
      if (!track) return;
      var section = car.closest('.krumb-article__related');
      var nav = section ? section.querySelector('[data-carousel-nav]') : null;
      var prev = nav ? nav.querySelector('[data-carousel-prev]') : null;
      var next = nav ? nav.querySelector('[data-carousel-next]') : null;

      function pageWidth() {
        var slide = track.querySelector('.krumb-carousel__slide');
        var slideW = slide ? slide.getBoundingClientRect().width : track.clientWidth;
        var styles = getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap) || 0;
        var per = Math.max(1, Math.round(track.clientWidth / (slideW + gap)));
        return (slideW + gap) * per;
      }
      function update() {
        if (!nav) return;
        var scrollable = track.scrollWidth - track.clientWidth > 2;
        if (!scrollable) { nav.setAttribute('hidden', ''); return; }
        nav.removeAttribute('hidden');
        if (prev) prev.disabled = track.scrollLeft <= 1;
        if (next) next.disabled = track.scrollLeft >= (track.scrollWidth - track.clientWidth - 1);
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -pageWidth(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: pageWidth(), behavior: 'smooth' }); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  function init() {
    buildTOC();
    buildCarousels();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
